import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMapPin: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49992 7.78272V11.3333C7.49992 11.6093 7.72392 11.8333 7.99992 11.8333C8.27592 11.8333 8.49992 11.6093 8.49992 11.3333V7.78272C10.0079 7.54072 11.1666 6.24133 11.1666 4.66667C11.1666 2.92067 9.74592 1.5 7.99992 1.5C6.25392 1.5 4.83325 2.92067 4.83325 4.66667C4.83325 6.24133 5.99192 7.54138 7.49992 7.78272ZM7.99992 2.5C9.19458 2.5 10.1666 3.472 10.1666 4.66667C10.1666 5.86133 9.19458 6.83333 7.99992 6.83333C6.80525 6.83333 5.83325 5.86133 5.83325 4.66667C5.83325 3.472 6.80525 2.5 7.99992 2.5ZM13.1666 12C13.1666 13.4253 10.9453 14.5 7.99992 14.5C5.05459 14.5 2.83325 13.4253 2.83325 12C2.83325 11.094 3.69392 10.3234 5.19325 9.88672C5.45859 9.81072 5.73592 9.96139 5.81325 10.2267C5.89059 10.4921 5.73792 10.7693 5.47326 10.8467C4.34059 11.1767 3.83325 11.664 3.83325 12C3.83325 12.6113 5.45659 13.5 7.99992 13.5C10.5433 13.5 12.1666 12.6113 12.1666 12C12.1666 11.664 11.6592 11.1767 10.5266 10.8467C10.2619 10.7693 10.1093 10.4921 10.1866 10.2267C10.2639 9.96139 10.5426 9.81072 10.8066 9.88672C12.3059 10.3234 13.1666 11.094 13.1666 12Z"
      fill={color}
    />
  </svg>
);

export default IconMapPin;
